import { memo } from 'react';
import { useParams } from 'react-router';
import StockVisiblePickerContainer from '../../containers/StockVisiblePickerContainer';
import useWarehouseStockUpdateVisible from '../../hooks/useWarehouseStockUpdateVisible';
import { WAREHOUSE_STATUS_MAP, WAREHOUSE_VISIBILITY_STATUS } from 'modules/inventory/common/constants/visibility-status';

type Props = {
  value?: boolean;
  button?: boolean;
  warehouseId?: string;
  rowId: string;
};

const WarehouseStockVisiblePicker = ({ value, rowId, button, warehouseId }: Props) => {
  const { id } = useParams();
  const {
    updateVisible,
    isLoading,
    value: lastValue,
  } = useWarehouseStockUpdateVisible(warehouseId || (id as string), rowId);

  return (
    <StockVisiblePickerContainer
      value={value}
      lastValue={lastValue}
      button={button}
      optionMap={WAREHOUSE_STATUS_MAP}
      options={WAREHOUSE_VISIBILITY_STATUS}
      updateVisible={updateVisible}
      isLoading={isLoading}
    />
  );
};
export default memo(WarehouseStockVisiblePicker);
